import { render, staticRenderFns } from "./xePivotTable.vue?vue&type=template&id=2d6f7950&scoped=true"
import script from "./xePivotTable.vue?vue&type=script&lang=js"
export * from "./xePivotTable.vue?vue&type=script&lang=js"
import style0 from "./xePivotTable.vue?vue&type=style&index=0&id=2d6f7950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f7950",
  null
  
)

export default component.exports